import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';

const TableChart = ({
	metricField,
	metricData,
	channels,
	metricInitialVal,
}) => {
	const [rowsData, setRowsData] = useState({});
	const [metricFilter, setMetricFilter] = useState(metricInitialVal);

	useEffect(() => {
		if (metricData) {
			const filterChannel = channels[0] && channels[0].value;

			if (filterChannel) {
				const filtered = Object.keys(metricData.tableData)
					.filter((key) => filterChannel === key)
					.reduce((obj, key) => {
						obj[key] = metricData.tableData[key];
						return obj;
					}, {});
				setRowsData(filtered);
			} else {
				setRowsData(metricData.tableData ? metricData.tableData : {});
			}
		}
	}, [metricData, channels]);

	useEffect(() => {
		if (metricField && metricField[0]) {
			const filterMetric = metricField[0].value;
			if (filterMetric) {
				setMetricFilter(filterMetric);
			} else {
				setMetricFilter(metricInitialVal);
			}
		}
	}, [metricField]);

	// console.log('rowsData', rowsData);
	// console.log('metricData', metricData);
	// console.log('metricFilter', metricFilter);

	return (
		<div className='p-4 '>
			<div className='mb-3 text-muted fw-bold' style={{ fontSize: '1.3rem' }}>
				{metricFilter ? metricFilter : null}
			</div>
			{Object.keys(rowsData).length &&
				Object.entries(rowsData).map(([key, value]) => {
					return (
						<div
							key={key}
							style={{ borderBottom: '1px solid #ddd' }}
							className='d-flex justify-content-between '>
							<div className='text-capitalize py-2'>{key} </div>
							<div> {metricFilter ? value[metricFilter] : ''}</div>
						</div>
					);
				})}
		</div>
	);
};

// const data = {
// 	socialMedia: { visitors: 20, redeemed: 100, active: 10, sales: 4000 },
// 	posm: { visitors: 202, redeemed: 200, active: 15, sales: 5000 },
// 	online: { visitors: 205, redeemed: 300, active: 36, sales: 6000 },
// 	offline: { visitors: 201, redeemed: 400, active: 33, sales: 7000 },
// };

export default TableChart;
